import InputWithFormat from './InputWithFormat';

const ORGANIZATION_NUMBER_FORMAT = '### ### ###';

const OrganizationNumberInput = ({ defaultValue, value = '', title, onChange, ...props }) => (
    <InputWithFormat
        {...props}
        format={ORGANIZATION_NUMBER_FORMAT}
        title={title ?? 'Organisasjonsnummer'}
        defaultValue={defaultValue ?? value}
        onChange={onChange}
    />
);

export default OrganizationNumberInput;
